import React from 'react';
import styled, { keyframes, css } from 'styled-components/macro';

const Wrapper = styled.div`
  width: 100%;
  max-width: 250px;
  display: flex;
  flex-direction: row;
`;

const CarWrapper = styled.div`
  position: relative;
  width: 50px;
  overflow: hidden;
`;

const moveCar = keyframes`
  0% {
    left: -25%;
  }
  100% {
    left: 100%;
  }
`;

const animationRule = css`
  ${moveCar} 3s linear infinite;
`;

const Car = styled.div`
  position: absolute;
  top: 0;
  width: 20px;
  transform: scaleX(-1);
  animation: ${animationRule};
`;

export default function UploadProgress() {
  return (
    <Wrapper>
      <div>Идет загрузка файла...</div>

      <CarWrapper>
        <Car>
          <span role="img" aria-label="Машина">🚚</span>
        </Car>
      </CarWrapper>
    </Wrapper>
  );
}
